var PollData_Poll_Settings_Permissions_ViewRole = /* @__PURE__ */ ((PollData_Poll_Settings_Permissions_ViewRole2) => {
  PollData_Poll_Settings_Permissions_ViewRole2["CREATOR"] = "CREATOR";
  PollData_Poll_Settings_Permissions_ViewRole2["VOTERS"] = "VOTERS";
  PollData_Poll_Settings_Permissions_ViewRole2["EVERYONE"] = "EVERYONE";
  PollData_Poll_Settings_Permissions_ViewRole2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return PollData_Poll_Settings_Permissions_ViewRole2;
})(PollData_Poll_Settings_Permissions_ViewRole || {});
var PollData_Poll_Settings_Permissions_VoteRole = /* @__PURE__ */ ((PollData_Poll_Settings_Permissions_VoteRole2) => {
  PollData_Poll_Settings_Permissions_VoteRole2["SITE_MEMBERS"] = "SITE_MEMBERS";
  PollData_Poll_Settings_Permissions_VoteRole2["ALL"] = "ALL";
  PollData_Poll_Settings_Permissions_VoteRole2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return PollData_Poll_Settings_Permissions_VoteRole2;
})(PollData_Poll_Settings_Permissions_VoteRole || {});
var PollData_Layout_PollLayout_Type = /* @__PURE__ */ ((PollData_Layout_PollLayout_Type2) => {
  PollData_Layout_PollLayout_Type2["LIST"] = "LIST";
  PollData_Layout_PollLayout_Type2["GRID"] = "GRID";
  PollData_Layout_PollLayout_Type2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return PollData_Layout_PollLayout_Type2;
})(PollData_Layout_PollLayout_Type || {});
var PollData_Layout_PollLayout_Direction = /* @__PURE__ */ ((PollData_Layout_PollLayout_Direction2) => {
  PollData_Layout_PollLayout_Direction2["LTR"] = "LTR";
  PollData_Layout_PollLayout_Direction2["RTL"] = "RTL";
  PollData_Layout_PollLayout_Direction2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return PollData_Layout_PollLayout_Direction2;
})(PollData_Layout_PollLayout_Direction || {});
var PollData_Design_PollDesign_Background_Type = /* @__PURE__ */ ((PollData_Design_PollDesign_Background_Type2) => {
  PollData_Design_PollDesign_Background_Type2["COLOR"] = "COLOR";
  PollData_Design_PollDesign_Background_Type2["IMAGE"] = "IMAGE";
  PollData_Design_PollDesign_Background_Type2["GRADIENT"] = "GRADIENT";
  PollData_Design_PollDesign_Background_Type2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return PollData_Design_PollDesign_Background_Type2;
})(PollData_Design_PollDesign_Background_Type || {});
export {
  PollData_Design_PollDesign_Background_Type,
  PollData_Layout_PollLayout_Direction,
  PollData_Layout_PollLayout_Type,
  PollData_Poll_Settings_Permissions_ViewRole,
  PollData_Poll_Settings_Permissions_VoteRole
};
//# sourceMappingURL=plugin_poll.enums.js.map
